<ax-icon
  *ngIf="showIcon"
  class="icon type-icon"
  [ngClass]="{single: isSingleRadio}"
  [name]="customIcon ? customIcon : 'card-text'"
></ax-icon>
<div>
  <div class="header">
    @if (!isSingleRadio) {
      <span class="label">{{ label }}<span *ngIf="required">&nbsp;*</span></span>
    }
  </div>

  <div class="radios">
    <mat-radio-group
      [name]="getName()"
      class="radio-group"
      [ngClass]="{readonly: readonly}"
      [formControl]="radioControl"
      [disabled]="form.disabled || readonly"
    >
      @if (isSingleRadio) {
        <mat-radio-button [value]="'true'" [disabled]="form.disabled || readonly">
          {{ label }}<span *ngIf="required">&nbsp;*</span>
        </mat-radio-button>
      } @else {
        <mat-radio-button
          *ngFor="let valueTranslation of valueLabels"
          [value]="valueTranslation.value"
          [disabled]="form.disabled || readonly"
        >
          {{ valueTranslation.label }}
        </mat-radio-button>
      }
    </mat-radio-group>

    <button
      axButton
      icon-button
      type="button"
      *ngIf="form?.enabled && hasValue && !readonly"
      (click)="clearValue()"
    >
      <ax-icon class="icon" name="close"></ax-icon>
    </button>
  </div>
</div>
<div class="hint-wrapper">
  <mat-hint class="hint" align="end" *ngIf="form.valid || form.untouched">
    {{ hint }}
  </mat-hint>
  <ax-property-error *ngIf="form.touched" [form]="form" [label]="label"></ax-property-error>
</div>
